/* Stylesheets */
import "./scss/vendors/bootstrap.scss"; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
// import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
// import './scss/fonts.scss';
// import './scss/vendors/energy-saver.scss';
import "./scss/vendors/color-theme.scss";
import "./scss/style.scss";

/* Scripts */
import { Offcanvas } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.
import { z } from 'zod';
import JsBarcode from 'jsbarcode';
import Validation from './js/vendors/validation';
import ColorTheme from "./js/vendors/color-theme";

// import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
// import { } from 'swiper/modules';
// const swiperTranslations = {
//     firstSlideMessage: `Questa è la prima slide`,
//     lastSlideMessage: `Questa è l'ultima slide`,
//     nextSlideMessage: `Vai alla prossima slide`,
//     paginationBulletMessage: `Vai alla slide {{index}}`,
//     prevSlideMessage: `Vai alla slide precedente`,
//     slideLabelMessage: `{{index}} di {{slidesLength}}`
// } // Oggetto da passare alla proprietà a11y: { ...options, ...swiperTranslations } dell'istanza Swiper - ref: https://docs.google.com/presentation/d/1dhMLaonvwWgX0t-fAxPU4PubI_u6QTrl10IfM6Badng/edit?slide=id.g3a1f0c75b34_0_0#slide=id.g3a1f0c75b34_0_0

// import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { faFreeB } from '@fortawesome/free-brands-svg-icons';
// import { faFreeS } from '@fortawesome/free-solid-svg-icons';
// import { faFreeR } from '@fortawesome/free-regular-svg-icons';
// import { faProS } from '@fortawesome/pro-solid-svg-icons';
// import { faProR } from '@fortawesome/pro-regular-svg-icons';
// import { faProL } from '@fortawesome/pro-light-svg-icons';
// import { faProT } from '@fortawesome/pro-thin-svg-icons';
// import { faProD } from '@fortawesome/pro-duotone-svg-icons';
// import { faDuotoneR } from '@fortawesome/duotone-regular-svg-icons';
// import { faDuotoneL } from '@fortawesome/duotone-light-svg-icons';
// import { faDuotoneT } from '@fortawesome/duotone-thin-svg-icons';
// import { faSharpS } from '@fortawesome/sharp-solid-svg-icons';
// import { faSharpR } from '@fortawesome/sharp-regular-svg-icons';
// import { faSharpL } from '@fortawesome/sharp-light-svg-icons';
// import { faSharpT } from '@fortawesome/sharp-thin-svg-icons';
// import { faSharpD } from '@fortawesome/sharp-duotone-solid-svg-icons';
// import { faSharpDR } from '@fortawesome/sharp-duotone-regular-svg-icons';
// import { faSharpDL } from '@fortawesome/sharp-duotone-light-svg-icons';
// import { faSharpDT } from '@fortawesome/sharp-duotone-thin-svg-icons';
// import { faFree } from '@fortawesome/fontawesome-free';
// import { faPro } from '@fortawesome/fontawesome-pro';
// library.add(faFreeB, faFreeS, faFreeR, faProS, faProR, faProL, faProT, faProD);
// library.add(faDuotoneR, faDuotoneL, faDuotoneT);
// library.add(faSharpS, faSharpR, faSharpL, faSharpT, faSharpD, faSharpDR, faSharpDL, faSharpDT);
// library.add(faFree, faPro);
// dom.i2svg();

// import EnergySaver from './js/vendors/energy-saver';

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const isDebug = process.env.NODE_ENV !== "production";

/* Variables and functions */
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

const goToAnchor = (el, offset = 0, behavior = "smooth") => {
    if (typeof el === "string") {
        el = document.querySelector(el);
    }

    if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: y,
            behavior: behavior,
        });
    }
};

const initCloseMenuByNav = () => {
    Array.from(document.querySelectorAll('.nav-item a'))
        .forEach((el) => el.addEventListener('click', (evt) => {
            // Verifica se il link contiene un'ancora, chiudi offcanvas e solo dopo che è chiuso esegui lo scroll
            const anchor = el.hash;
            if (anchor && anchor.length > 1) {
                const offcanvasElement = document.querySelector('#offcanvasNavbar');
                if (offcanvasElement) {
                    const offcanvasMenu = Offcanvas.getInstance(offcanvasElement);
                    if (offcanvasMenu) {
                        offcanvasMenu.hide();
                        offcanvasElement.addEventListener('hidden.bs.offcanvas', function () {
                            goToAnchor(anchor);
                        }, { once: true });
                    }
                }
            }
        })
    );
};

const initProgressLevels = () => {
    const progress = document.querySelector('.progress[role="progressbar"]');
    const container = document.querySelector('.progress__levels');
    const levels = container?.querySelectorAll('.progress__level');
    
    if (!progress) return;

    const min = parseFloat(progress.getAttribute('aria-valuemin')) || 0;
    const max = parseFloat(progress.getAttribute('aria-valuemax')) || 100;
    const now = parseFloat(progress.getAttribute('aria-valuenow')) || 0;

    if (max <= min) return;

    const calculatePercent = (val) => {
        const percent = ((val - min) / (max - min)) * 100;
        return `${Math.max(0, Math.min(100, percent))}%`;
    };

    if (levels && levels.length > 0) {
        levels.forEach(level => {
            const val = parseFloat(level.dataset.value);
            level.style.left = calculatePercent(val);
        });
    }

    const pointsLabel = document.querySelector('.progress__point');
    const progressBar = progress.querySelector('.progress-bar');
    
    // Inizializza larghezza e posizione a 0
    if (progressBar) {
        progressBar.style.width = '0%';
    }
    if (pointsLabel) {
        pointsLabel.style.left = '0%';
        
        // Ascolta la fine della transizione per aggiungere la classe 'show'
        pointsLabel.addEventListener('transitionend', (e) => {
            if (e.propertyName === 'left') {
                pointsLabel.closest('.progress__points')?.classList?.add('show');
            }
        });
    }

    // Observer per avviare l'animazione quando l'elemento entra nel viewport
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (progressBar) {
                    progressBar.style.width = calculatePercent(now);
                }
                if (pointsLabel) {
                    const val = parseFloat(pointsLabel.dataset.value);
                    pointsLabel.style.left = calculatePercent(val);
                }
                obs.unobserve(entry.target);
            }
        });
    }, {
        threshold: 1 // Si attiva quando almeno il 100% della progress bar è visibile
    });

    const wrapper = progress.closest('.dashboard__details--progress') || progress;
    observer.observe(wrapper);
};

const initBarcode = () => {
    JsBarcode('#moratoBarcode')?.init();
};

const initForms = () => {
    const signinForm = document.getElementById('signinForm');
    if (signinForm) {
        const val = new Validation(signinForm);
    }
};

const initBirthdayCodeCopy = () => {
    document.querySelectorAll('.dashboard__birthday-code__copy').forEach((btn) => {
        btn.addEventListener('click', async () => {
            const code = btn.dataset.code;
            if (!code) return;
            try {
                await navigator.clipboard.writeText(code);
                const labelCopied = btn.dataset.labelCopied || 'Copiato!';
                btn.textContent = labelCopied;
                btn.classList.add('copied');
                setTimeout(() => {
                    btn.textContent = btn.dataset.labelCopy || 'Copia il codice';
                    btn.classList.remove('copied');
                }, 2000);
            } catch {
                // clipboard non disponibile, seleziona il testo come fallback
                const codeEl = document.getElementById('birthdayPromoCode');
                if (codeEl) {
                    const range = document.createRange();
                    range.selectNodeContents(codeEl);
                    const sel = window.getSelection();
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        });
    });
};

/* Ready callback function */
ready(() => {
    ColorTheme();
    initWebpackVersion();
    initCloseMenuByNav();
    initProgressLevels();
    initBarcode();
    initForms();
    initBirthdayCodeCopy();
});
